// import ExcelJS from "exceljs";

// export async function exportToExcel(filteredData, storess) {
//   console.log("filteredData excel", filteredData);

//   const workbook = new ExcelJS.Workbook();
//   const sheet = workbook.addWorksheet("Sales");

//   const headerStyle = {
//     font: { bold: true, color: { argb: "FFFFFFFF" } },
//     fill: {
//       type: "pattern",
//       pattern: "solid",
//       fgColor: { argb: "FF0070C0" },
//     },
//   };

//   // 1) Detail section with 3 payment‐type columns
//   const headerRow = sheet.addRow([
//     "Brand",
//     "Store",
//     "Date",
//     "Tran ID",
//     "Sales",
//     "Payment Type 1",
//     "Amount 1",
//     "Payment Type 2",
//     "Amount 2",
//     "Payment Type 3",
//     "Amount 3",
//     "Status",
//   ]);
//   headerRow.eachCell((cell) => Object.assign(cell, headerStyle));

//   filteredData.forEach((data) => {
//     sheet.addRow([
//       "Angels Pizza",
//       storess,
//       data.tran_date,
//       data.tran_id,
//       data.total,
//       data.paymenttype,
//       data.paymenttypetotal,
//       data.paymenttype2,
//       data.paymenttype2total,
//       data.paymenttype3,
//       data.paymenttype3total,
//       data.status,
//     ]);
//   });

//   // 2) Payment Type Summary (across all three slots)
//   sheet.addRow([]);
//   sheet.addRow(["\uD83D\uDCB3 PAYMENT TYPE SUMMARY"]);
//   const summaryHeader = sheet.addRow(["Payment Type", "Count", "Total Sales"]);
//   summaryHeader.eachCell((cell) => Object.assign(cell, headerStyle));

//   const paymentSummary = {};
//   filteredData
//     .filter((data) => data.status === "C")
//     .forEach((data) => {
//       ["", "2", "3"].forEach((suf) => {
//         const type = data[`paymenttype${suf}`]?.trim();
//         const amt = parseFloat(data[`paymenttype${suf}total`]) || 0;
//         if (type && type !== "-") {
//           if (!paymentSummary[type]) {
//             paymentSummary[type] = { count: 0, total: 0 };
//           }
//           paymentSummary[type].count++;
//           paymentSummary[type].total += amt;
//         }
//       });
//     });
//   Object.entries(paymentSummary).forEach(([type, { count, total }]) => {
//     sheet.addRow([type.toUpperCase(), count, total]);
//   });

//   // 3) Transaction Type Summary (unchanged)
//   sheet.addRow([]);
//   sheet.addRow(["\uD83D\uDDFE TRANSACTION TYPE SUMMARY"]);
//   const txnHeader = sheet.addRow(["Transaction Type", "Count", "Total Sales"]);
//   txnHeader.eachCell((cell) => Object.assign(cell, headerStyle));

//   const transactionTypes = {
//     D: "Dinein",
//     K: "Drive-Thru",
//     T: "Take-out",
//     G: "GrabFood",
//     P: "Pickup",
//     U: "Delivery",
//     B: "deltime",
//     F: "FoodPanda",
//   };
//   const tranSummary = {};
//   filteredData
//     .filter((data) => data.status === "C")
//     .forEach(({ tran_type, total }) => {
//       const code = tran_type?.trim();
//       if (code && transactionTypes[code]) {
//         if (!tranSummary[code]) {
//           tranSummary[code] = { count: 0, total: 0 };
//         }
//         tranSummary[code].count++;
//         tranSummary[code].total += parseFloat(total || 0);
//       }
//     });
//   Object.entries(tranSummary).forEach(([code, { count, total }]) => {
//     sheet.addRow([transactionTypes[code], count, total]);
//   });

//   // --- NEW: Compute totals for Report Summary from filteredData ---
//   const totals = filteredData.reduce(
//     (acc, d) => {
//       const total = parseFloat(d.total) || 0;
//       const discount = parseFloat(d.discount_amount) || 0;
//       const pretax = parseFloat(d.total_pretax) || 0;
//       const tax = parseFloat(d.total_tax) || 0;
//       const taxfree = parseFloat(d.total_taxfree) || 0;
//       const status = d.status?.trim();

//       if (status === "C") {
//         acc.gross += total; // Gross Sales
//         acc.net += total - tax; // Net Sales
//         acc.pretax += pretax;
//         acc.tax += tax;
//         acc.taxfree += taxfree;
//         acc.discount += discount;
//       }
//       if (status === "V") {
//         acc.voidAmount += total;
//         acc.voidCount += 1;
//       }
//       return acc;
//     },
//     {
//       gross: 0,
//       net: 0,
//       pretax: 0,
//       tax: 0,
//       taxfree: 0,
//       discount: 0,
//       voidAmount: 0,
//       voidCount: 0,
//     }
//   );

//   // --- Report Summary section (placed under Transaction Type Summary) ---
//   sheet.addRow([]);
//   sheet.addRow(["📊 REPORT SUMMARY"]);
//   const reportHeader = sheet.addRow(["Metric", "Value"]);
//   reportHeader.eachCell((cell) => Object.assign(cell, headerStyle));

//   const rows = [
//     ["Total Gross Sales", totals.gross],
//     ["Total Net Sales (Total - Discount)", totals.net],
//     ["Total Pretax", totals.pretax],
//     ["Total Tax", totals.tax],
//     ["Total Tax Free", totals.taxfree],
//     ["Total Discount", totals.discount],
//     ["Total Void Amount", totals.voidAmount],
//     ["Total Void Count", totals.voidCount],
//   ];

//   rows.forEach(([label, val], idx) => {
//     const r = sheet.addRow([label, val]);
//     // Format currency for money rows, leave void count as integer
//     if (label !== "Total Void Count") {
//       r.getCell(2).numFmt = '"₱"#,##0.00';
//     }
//   });

//   // 4) trigger download
//   const buf = await workbook.xlsx.writeBuffer();
//   const blob = new Blob([buf], {
//     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//   });
//   const url = URL.createObjectURL(blob);
//   const link = document.createElement("a");
//   link.href = url;
//   link.download = "sales-report.xlsx";
//   link.click();
//   URL.revokeObjectURL(url);
// }

import ExcelJS from "exceljs";

export async function exportToExcel(filteredData, storess) {
  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet("Sales");

  const headerStyle = {
    font: { bold: true, color: { argb: "FFFFFFFF" } },
    fill: { type: "pattern", pattern: "solid", fgColor: { argb: "FF0070C0" } },
  };

  // --- Updated Header: Added Items after Status ---
  const headerRow = sheet.addRow([
    "Brand",
    "Store",
    "Date",
    "Tran ID",
    "Sales",
    "Payment Type 1",
    "Amount 1",
    "Payment Type 2",
    "Amount 2",
    "Payment Type 3",
    "Amount 3",
    "Status",
    "Items (Code - Description - Amount)", // new column
  ]);
  headerRow.eachCell((cell) => Object.assign(cell, headerStyle));

  filteredData.forEach((data) => {
    // Extract items -> only code, description, and AMOUNT
    let itemsText = "";
    if (Array.isArray(data.items)) {
      itemsText = data.items
        .map((item) => {
          const code = item.code || "";
          const desc = item.description || "";
          const amountProp = item.customProperties?.find(
            (p) => p.codeName === "AMOUNT"
          );
          const amount = amountProp?.value || "0.00";
          return `${code} - ${desc} - ₱${amount}`;
        })
        .join("\n"); // put each item on a new line
    }

    sheet.addRow([
      "Angels Pizza",
      storess,
      data.tran_date,
      data.tran_id,
      data.total,
      data.paymenttype,
      data.paymenttypetotal,
      data.paymenttype2,
      data.paymenttype2total,
      data.paymenttype3,
      data.paymenttype3total,
      data.status,
      itemsText, // new column
    ]);
  });

  // (the rest of your summaries & report code stays unchanged)

  // 2) Payment Type Summary (across all three slots)
  sheet.addRow([]);
  sheet.addRow(["\uD83D\uDCB3 PAYMENT TYPE SUMMARY"]);
  const summaryHeader = sheet.addRow(["Payment Type", "Count", "Total Sales"]);
  summaryHeader.eachCell((cell) => Object.assign(cell, headerStyle));

  const paymentSummary = {};
  filteredData
    .filter((data) => data.status === "C")
    .forEach((data) => {
      ["", "2", "3"].forEach((suf) => {
        const type = data[`paymenttype${suf}`]?.trim();
        const amt = parseFloat(data[`paymenttype${suf}total`]) || 0;
        if (type && type !== "-") {
          if (!paymentSummary[type]) {
            paymentSummary[type] = { count: 0, total: 0 };
          }
          paymentSummary[type].count++;
          paymentSummary[type].total += amt;
        }
      });
    });
  Object.entries(paymentSummary).forEach(([type, { count, total }]) => {
    sheet.addRow([type.toUpperCase(), count, total]);
  });

  // 3) Transaction Type Summary (unchanged)
  sheet.addRow([]);
  sheet.addRow(["\uD83D\uDDFE TRANSACTION TYPE SUMMARY"]);
  const txnHeader = sheet.addRow(["Transaction Type", "Count", "Total Sales"]);
  txnHeader.eachCell((cell) => Object.assign(cell, headerStyle));

  const transactionTypes = {
    D: "Dinein",
    K: "Drive-Thru",
    T: "Take-out",
    G: "GrabFood",
    P: "Pickup",
    U: "Delivery",
    B: "deltime",
    F: "FoodPanda",
    H: "Tablevibe",
  };
  const tranSummary = {};
  filteredData
    .filter((data) => data.status === "C")
    .forEach(({ tran_type, total }) => {
      const code = tran_type?.trim();
      if (code && transactionTypes[code]) {
        if (!tranSummary[code]) {
          tranSummary[code] = { count: 0, total: 0 };
        }
        tranSummary[code].count++;
        tranSummary[code].total += parseFloat(total || 0);
      }
    });
  Object.entries(tranSummary).forEach(([code, { count, total }]) => {
    sheet.addRow([transactionTypes[code], count, total]);
  });

  // --- NEW: Compute totals for Report Summary from filteredData ---
  const totals = filteredData.reduce(
    (acc, d) => {
      const total = parseFloat(d.total) || 0;
      const discount = parseFloat(d.discount_amount) || 0;
      const pretax = parseFloat(d.total_pretax) || 0;
      const tax = parseFloat(d.total_tax) || 0;
      const taxfree = parseFloat(d.total_taxfree) || 0;
      const status = d.status?.trim();

      if (status === "C") {
        acc.gross += total; // Gross Sales
        acc.net += total - tax; // Net Sales
        acc.pretax += pretax;
        acc.tax += tax;
        acc.taxfree += taxfree;
        acc.discount += discount;
      }
      if (status === "V") {
        acc.voidAmount += total;
        acc.voidCount += 1;
      }
      return acc;
    },
    {
      gross: 0,
      net: 0,
      pretax: 0,
      tax: 0,
      taxfree: 0,
      discount: 0,
      voidAmount: 0,
      voidCount: 0,
    }
  );

  // --- Report Summary section (placed under Transaction Type Summary) ---
  sheet.addRow([]);
  sheet.addRow(["📊 REPORT SUMMARY"]);
  const reportHeader = sheet.addRow(["Metric", "Value"]);
  reportHeader.eachCell((cell) => Object.assign(cell, headerStyle));

  const rows = [
    ["Total Gross Sales", totals.gross],
    ["Total Net Sales (Total - Discount)", totals.net],
    ["Total Pretax", totals.pretax],
    ["Total Tax", totals.tax],
    ["Total Tax Free", totals.taxfree],
    ["Total Discount", totals.discount],
    ["Total Void Amount", totals.voidAmount],
    ["Total Void Count", totals.voidCount],
  ];

  rows.forEach(([label, val], idx) => {
    const r = sheet.addRow([label, val]);
    // Format currency for money rows, leave void count as integer
    if (label !== "Total Void Count") {
      r.getCell(2).numFmt = '"₱"#,##0.00';
    }
  });

  const buf = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buf], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = "sales-report.xlsx";
  link.click();
  URL.revokeObjectURL(url);
}
